module.exports = __webpack_public_path__ + "5db8320545159867b16400836922f665.svg";